/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $EditContract = {
  properties: {
    contractId: {
      type: 'string',
      isRequired: true,
    },
    contractInfo: {
      type: 'CreateContract',
      isRequired: true,
    },
  },
} as const;
